import join from 'url-join';
import Moment from 'moment/moment';
import axios from '../axios-default';
import { ApiServerUrl } from '../../src/config.json';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

export function downloadImages(caseFile, type, excludeDbx = false) {
    let photosList = [],
        date = null;
    Object.entries(caseFile).map(([key, value]) => {
        if (key.includes(type) && !key.endsWith('later') && value && (!excludeDbx || !/^dbx::/.test(value))) {
            photosList.push(join(ApiServerUrl, value));
        }
    });
    date = Moment(caseFile.created_date).format('YYYY-MM-DD');
    for (let i = 0; i < photosList.length; i++) {
        downloadFile(photosList[i], date);
    }
}

/**
 * Downloads the provided file URLs as a ZIP archive.
 *
 * @param {string[]} fileUrls - URLs of the files to include in the archive.
 * @param {string} zipFileName - Name of the downloaded ZIP file.
 * @returns {Promise<void>}
 */
export async function downloadFilesAsZip(fileUrls, zipFileName) {
    const zip = new JSZip();

    for (const fileUrl of fileUrls) {
        const { data } = await axios.get(fileUrl, { responseType: 'blob' });
        const fileName = decodeURIComponent(fileUrl.split('?')[0].split('/').pop());
        zip.file(fileName, data);
    }

    const content = await zip.generateAsync({ type: 'blob' });
    saveAs(content, zipFileName);
}

function downloadFile(file, date, type = 'image/*') {
    axios.get(file, { responseType: 'blob' }).then(({ data }) => {
        let url = window.URL.createObjectURL(data);

        var newImageName = file.split('/')[file.split('\/').length - 1]; //using the server image name

        Object.assign(document.createElement('a'), { download: `${date}-${newImageName}`, href: url }).click();
        window.URL.revokeObjectURL(url);
    });
}

/**
 * Filters the given data object based on the keys that start with the specified text.
 *
 * @param {string} text - The text to filter the keys with.
 * @param {object} data - The data object to filter.
 * @returns {object} - The filtered data object.
 */
export function filterObjectData(text, data) {
    const filteredData = Object.fromEntries(Object.entries(data).filter(([key]) => !key.startsWith(text)));

    return filteredData;
}

export function replaceCurlyBracketText(str, replacement) {
    return str.replace(/\{\{.*?\}\}/g, replacement);
}

export const getOperatingSystem = () => {
    const userAgent = window.navigator.userAgent;

    if (userAgent.includes('Win')) return 'Windows';
    if (userAgent.includes('Mac') && !userAgent.includes('like Mac')) return 'MacOS';
    if (userAgent.includes('Linux')) return 'Linux';
    if (userAgent.includes('Android')) return 'Android';
    if (userAgent.includes('like Mac')) return 'iOS';

    return undefined;
};

export const getSaveZipFileOption = (baseOpt = { type: 'blob' }) => {
    let option = { ...baseOpt };
    const userOs = getOperatingSystem();
    if (userOs === 'Windows') {
        option.platform = 'DOS';
    }
    return option;
};
export const updateParams = (targetSentence, paramToText) => {
    try {
        const regex = /{{param}}/g;
        const text = targetSentence.replace(regex, paramToText);
        return text;
    } catch (e) {
        console.error(e);
        return targetSentence;
    }
};

export const isEmpty = (value) => {
    return value === undefined || value === null || value === '';
};

export const isValidUrl = (string) => {
    try {
        new URL(string);
        return true;
    } catch (error) {
        return false;
    }
};
